// 升级策略
export const UPGRADE_STRATEGY = [
  {
    country: '228',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '166',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '200',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '14',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '199',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '70',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '204',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '142',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '167',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '2',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '125',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '49',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '78',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '76',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '44',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '309',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '80',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '24',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '106',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 0
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '135',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '213',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '114',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '291',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '190',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '130',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '189',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '62',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '38',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '139',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '171',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '205',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '32',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '187',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '27',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '289',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '185',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '84',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '50',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '102',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '218',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '168',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '293',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '134',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '88',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '206',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '195',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '6',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '61',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '81',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '155',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '196',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '108',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '57',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '103',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '93',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '68',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '212',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '292',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '91',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '65',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '55',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '202',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '133',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '186',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '116',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '4',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '157',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '5',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '211',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '290',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '132',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '86',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '64',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '3',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '153',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '36',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '145',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '109',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '12',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '105',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '175',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '19',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '9',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '152',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '192',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '82',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '90',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '37',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '21',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '47',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '160',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '13',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '42',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '74',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '11',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '122',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '177',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '226',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '118',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '7',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '124',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '227',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '188',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '217',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '33',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '92',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '54',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '39',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '51',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '29',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '23',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '107',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '120',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '183',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '53',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '179',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '8',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '191',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '222',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '141',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '15',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '115',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '307',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '176',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '67',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '198',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '17',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '162',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '156',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '158',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '194',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '121',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '34',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '94',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '184',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '137',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '154',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '20',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '151',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '174',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '112',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '223',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '215',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '169',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '203',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '63',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '173',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '69',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '138',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '220',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '87',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '40',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '197',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '181',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '178',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '164',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '296',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '26',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '129',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '221',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '73',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '96',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '28',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '216',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '131',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '30',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '182',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '165',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '71',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '75',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '224',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '59',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '210',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '46',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '41',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '201',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '140',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '163',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '77',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '119',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '0',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '22',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '25',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '207',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '136',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '117',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '1',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '128',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '149',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '161',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '95',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '143',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '111',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '148',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '52',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '208',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '18',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '147',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '60',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '31',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '144',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '219',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '294',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '85',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '79',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '146',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '159',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '172',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '126',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '99',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '150',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '45',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '110',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '83',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '180',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '35',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '225',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '98',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '113',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '104',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '66',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '308',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '101',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '100',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '48',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '72',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '56',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '295',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '16',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '10',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '297',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '89',
    epProStrategy: {
      strategy: 0
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: false,
    showEpWord: false
  },
  {
    country: '43',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '123',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '127',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '193',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '214',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '58',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: true
  },
  {
    country: '170',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  },
  {
    country: '97',
    epProStrategy: {
      strategy: 1
    },
    hikIdStrategy: {
      strategy: 1
    },
    showEP: true,
    showEpWord: false
  }
];
